import { render, staticRenderFns } from "./tprDeliveryPrice.vue?vue&type=template&id=f1fc9d1e&"
import script from "./tprDeliveryPrice.vue?vue&type=script&lang=js&"
export * from "./tprDeliveryPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports